// The Vue build version to load with the `import` command
import "@babel/polyfill";

import Vue from 'vue';
import VuePapaParse from 'vue-papa-parse'

import BootstrapVue, { LayoutPlugin } from 'bootstrap-vue';
// import Axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faTimes,
  faFileContract,
  faHotel,
  faTrash,
  faUserNurse,
  faUserTie,
  faUserMd,
  faUserCog,
  faUsers,
  faQuestionCircle,
  faInfoCircle,
  faHome,
  faVenus,
  faMars,
  faPowerOff,
  faCircle,
  faPlus,
  faMinus,
  faEdit,
  faCheckSquare,
  faEye,
  faEyeSlash,
  faCaretLeft,
  faInfo,
  faDownload,
  faReply,
  faFileImport,
  faChevronDown,
  faChevronUp,
  faSquare,
  faUserPlus,
  faSyncAlt,
  faSignInAlt,
  faUndo,
  faSave,
  faExclamationTriangle,
  faSearch
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueI18n from 'vue-i18n';
import store from './store';
import App from './App.vue';
import router from './router';

import "@fortawesome/fontawesome-free/css/all.css";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-swatches/dist/vue-swatches.css';

library.add(faCheck);
library.add(faTimes);
library.add(faFileContract);
library.add(faHotel);
library.add(faTrash);
library.add(faUserTie); // Director
library.add(faUserNurse); // Nurse
library.add(faUserMd); // Doctor
library.add(faUserCog); // Housekeeper / secretary
library.add(faUsers); // Animator
library.add(faQuestionCircle); // Unknown
library.add(faInfoCircle); // Info
library.add(faHome); // Home
library.add(faVenus); // Female
library.add(faMars); // Male
library.add(faPowerOff); // Power off
library.add(faCircle); // Circle
library.add(faPlus); // Plus
library.add(faMinus); // Moins
library.add(faEdit); // Edit
library.add(faCheckSquare); // Check
library.add(faEyeSlash);
library.add(faEye);
library.add(faCaretLeft);
library.add(faInfo);
library.add(faDownload);
library.add(faReply);
library.add(faFileImport);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faSquare);
library.add(faUserPlus);
library.add(faSyncAlt);
library.add(faSignInAlt);
library.add(faUndo);
library.add(faSave);
library.add(faExclamationTriangle);
library.add(faSearch);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(LayoutPlugin);
Vue.use(VueI18n);
Vue.use(VuePapaParse)

function loadLocaleMessages() {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}


const i18n = new VueI18n(
  {
    locale: 'fr',
    messages: loadLocaleMessages(),
  },
  {
    locale: 'en',
    messages: loadLocaleMessages(),
  },
);

// eslint-disable-next-line import/prefer-default-export
export const operationBus = new Vue();


const toast = Vue.mixin({
  methods: {
    showToast(type, message, title, delay = 5000, noBtn = true, noHide = false, pos = 'b-toaster-top-right') {
      this.$bvToast.toast(message, {
        noCloseButton: noBtn,
        title: title,
        variant: type,
        autoHideDelay: delay,
        noAutoHide: noHide,
        toaster: pos
      });
    },
    showToastError(message, title, delay = 5000, noBtn = true, noHide = false, pos = 'b-toaster-top-right'){
      this.showToast('danger', message, title, delay, noBtn, noHide, pos);
    }
  }
});


/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  beforeCreate() {
    store.commit('user/initialiseStore');
  },
  template: '<App/>',
  i18n,
  mixins: [toast],
});
